import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

/**
 * @param {object} root
 * @param {boolean} root.disabled
 * @param {Function} root.onClick
 * @param {string} root.value - Formatted date label; always supplied by react-datepicker
 *   when it clones `customInput`.
 * @param {boolean} root.isModalOpen
 * @returns {React.ReactComponentElement} - TimeSpanButton component
 */
function TimeSpanButton({
  disabled = false, onClick = null, value, isModalOpen = false,
}) {
  const disabledStyle = { zIndex: 1, opacity: 0.65, cursor: 'not-allowed' };
  const isBtnDisabled = disabled || isModalOpen;
  const btnStyle = isBtnDisabled ? disabledStyle : {};
  return (
    <Button
      className="btn btn-darken"
      onClick={onClick}
      disabled={isBtnDisabled}
      autoFocus={false}
      style={btnStyle}
    >
      {value}
    </Button>
  );
}

TimeSpanButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool,
};

export default TimeSpanButton;
